<!-- Start of Selection -->
<div class="location-finder-wrap lc-lst-finder" [ngClass]="{'lc-lst-finder-expand': isLocationClicked, 'from-mobile-app': isFromMobileApp}">
  <!-- End of Selection -->
  <div class="search-wrap hungery-mobile-search-wrap" [class.view-searchbar]="isSearchBarActive" [class.has-qr-button]="shouldShowQRButton" [class.listing-location-expanded]="isDesktopLocationSearchOpen"
       [class.mobile-location-editing]="isMobileLocationSearchOpen"
       [class.listing-location-opening]="isDesktopLocationOpening"
       [class.listing-location-closing]="isDesktopLocationClosing">
    <!-- Share the floating controls' flex row and keyboard offset. -->
    <app-mobile-location-dock #mobileLocationDock
                              [open]="isMobileLocationSearchOpen"
                              [inlineWithControls]="true"
                              [originRect]="mobileLocationOriginRect"
                              [isClear]="clearLocation"
                              [selectedAddress]="selectedLocation?.address || null"
                              (locationSelected)="onLocationSelected($event)">
      <ng-container *ngTemplateOutlet="listingOpenClosePills"></ng-container>
    </app-mobile-location-dock>
    <div class="form-group">
      <div class="location-chip desktop-location-chip d-none d-md-flex" data-tour="location-control"
           [attr.role]="isDesktopLocationSearchOpen ? null : 'button'"
           [attr.tabindex]="isDesktopLocationSearchOpen ? null : 0"
           (keydown.enter)="onDesktopLocationKey($event)" (keydown.space)="onDesktopLocationKey($event)"
           [class.desktop-location-expanded]="isDesktopLocationSearchOpen"
           *ngIf="!isFromMobileApp"
           (click)="openDesktopLocationSearch($event)">
        <ng-container *ngIf="!isDesktopLocationSearchOpen; else listingDesktopLocationEditor">
          <img src="./assets/images/ic-location.svg" alt="Icon" />
          <h6 ngbTooltip="{{city}}">
            {{ (city ? city : 'Location') }}
          </h6>
        </ng-container>
        <ng-template #listingDesktopLocationEditor>
          <img src="./assets/images/ic-location.svg" alt="Icon" />
          <app-location-search #desktopLocationSearch
                               (locationSelected)="onLocationSelected($event)"
                               [isClear]="clearLocation"
                               [selectedAddress]="city">
          </app-location-search>
        </ng-template>
      </div>

      <input class="form-control custome-border-color" #restaurantSearchBar type="search"
             [(ngModel)]="searchText" (ngModelChange)="onSearch($event)"
             placeholder="Search" aria-label="Search" (blur)="onBlur()" />
      <div class="btn-grps">
        <!-- preventDefault on mousedown keeps focus in the input: otherwise the blur fires
             onBlur(), whose timer closes the whole bar before this click lands. -->
        <button type="button" class="btn btn-clear-search" (click)="clearSearchBar()"
                (mousedown)="$event.preventDefault()"
                [ngClass]="{'d-none':isclearButtonShow}">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                  fill="currentcolor" />
          </svg>
        </button>
        <button *ngIf="shouldShowQRButton" class="btn btn-scan btn-view" [ngClass]="{'btn-clicked':isQRScanBtnClick}" id="scanBtn"
                (click)="isQRScanBtnClick=!isQRScanBtnClick;QRScanClick()">
          <div class="svg-wrap mod-svg-wrapx">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1229_1454)">
                <g clip-path="url(#clip1_1229_1454)">
                  <path d="M1.5 10.8333V1.5H10.8333V10.8333H1.5ZM5 5V7.33333H7.33333V5H5ZM13.1667 10.8333V1.5H22.5V10.8333H13.1667ZM16.6667 5V7.33333H19V5H16.6667ZM1.5 13.1667V22.5H10.8333V13.1667H1.5ZM7.33333 16.6667V19H5V16.6667H7.33333ZM16.6667 13.1667H13.1667V15.5H16.6667V20.1667H15.5V17.8333H13.1667V22.5H17.8333V20.1667H20.1667V22.5H22.5V19H20.1667V17.8333H19V16.6667H22.5V13.1667H19V15.5H16.6667V13.1667Z" fill="currentColor" />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_1229_1454">
                  <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                </clipPath>
                <clipPath id="clip1_1229_1454">
                  <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                </clipPath>
              </defs>
            </svg>

          </div>
        </button>
        <button class="btn btn-view-text d-md-flex d-none" *ngIf="!isFromMobileApp" [ngClass]="{'btn-clicked':showOpen}"
                (click)="showOpenResturant()" title="Open">
          Open
        </button>
        <button class="btn btn-view-text d-md-flex d-none" *ngIf="!isFromMobileApp" [ngClass]="{'btn-clicked':showClose}"
                (click)="showCloseResturant()" title="Closeby">
          Closeby
        </button>
        <div class="filter-dropdown chips-position" [class.d-none]="myDrop.isOpen()">
          <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap d-md-none">
            <div class="chips-inner">
              <div class="chip" *ngFor="let chips of displayFilterChips">
                <span>{{chips.name}}</span>
                <button (click)="removeChips(chips);onfilter($event);" class="btn">
                  <img src="./assets/images/ic-close.svg" alt="Icon">
                </button>
              </div>
            </div>
          </div>
        </div>
        <div ngbDropdown placement="bottom-end" [autoClose]="'outside'" #myDrop="ngbDropdown" class="f-drop-wrap" [ngClass]="{'has-chips': displayFilterChips?.length >= 1}" (openChange)="$event && onDropdownShown()">
          <button class="btn btn-filter btn-view" [ngClass]="{'btn-clicked':isFilterBtnClick}"
                  (click)="isFilterBtnClick=!isFilterBtnClick" id="dropdown-filter" ngbDropdownToggle>
            <div class="svg-wrap mod-svg-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1229_1455)">
                  <g clip-path="url(#clip1_1229_1455)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.92017 3.82601C2.10304 3.68919 2.32894 3.60499 2.55485 3.60499C2.72262 3.60293 2.88859 3.63893 3.03977 3.71014C3.19094 3.78136 3.3232 3.88586 3.42619 4.01546L9.5901 11.7408V17.9084L11.4296 19.6976C11.8491 20.1081 11.8491 20.7817 11.4296 21.1921C11.01 21.6026 10.3216 21.6026 9.90206 21.1921L7.43864 18.7714V12.467L1.72654 5.31003V5.2995C1.36079 4.84693 1.44685 4.18386 1.92017 3.82601ZM16.0445 13.0238V10.9724H16.0767L22.2729 3.20504C22.4476 2.98563 22.5264 2.70748 22.4922 2.43138C22.4579 2.15528 22.3133 1.90368 22.09 1.73155C21.8856 1.5842 21.6597 1.5 21.4231 1.5H6.36292C6.12626 1.5 5.90036 1.5842 5.69597 1.73155C5.47268 1.90368 5.32811 2.15528 5.29385 2.43138C5.25958 2.70748 5.3384 2.98563 5.51309 3.20504L11.7093 10.9724H11.7415V17.1506C11.7212 17.3099 11.7387 17.4716 11.7929 17.6231C11.847 17.7747 11.9362 17.9119 12.0535 18.0241L12.5001 18.4611C12.5155 16.0388 13.9662 13.9572 16.0445 13.0238Z" fill="currentcolor" />
                    <path d="M14.5 17.5H17.5V14.5H19.5V17.5H22.5V19.5H19.5V22.5H17.5V19.5H14.5V17.5Z" fill="currentcolor" />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_1229_1455">
                    <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                  </clipPath>
                  <clipPath id="clip1_1229_1455">
                    <rect width="23" height="23" fill="white" transform="translate(1.5 1.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdown-filter" class="filter-dropdown" #filterDropdownMenu
               [attr.aria-busy]="isLoadingFilters"
               [class.mobile-location-editing]="isMobileLocationSearchOpen"
               (click)="$event.stopPropagation()"
               (touchstart)="$event.stopPropagation()"
               (touchmove)="preventScrollClose($event)" (wheel)="preventScrollClose($event)">
            <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap d-none d-md-flex">
              <div class="chips-inner">
                <div class="chip" *ngFor="let chip of displayFilterChips">
                  <span>{{chip.name}}</span>
                  <button (click)="removeChips(chip);onfilter($event);" class="btn">
                    <img src="./assets/images/ic-close.svg" alt="Icon">
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-wrapper">
              <div ngbNav #nav="ngbNav" [(activeId)]="active" (activeIdChange)="activeInner='1'"
                   class="nav-pills outer-tabs">
                <ng-container ngbNavItem="place">
                  <button ngbNavLink>Place</button>

                  <ng-template ngbNavContent>
                    <div class="inner-tab-block">
                      <div ngbNav #nav="ngbNav" [(activeId)]="activeInner" class="nav-tabs">
                        <!-- The listing API declares @FilterByRating but never applies it. The tab
                             stays visible and announces itself; its id is not "1" so the panel
                             still opens on Price Range. -->
                        <ng-container ngbNavItem="rating">
                          <button ngbNavLink ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
                            <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                            By Rating
                          </button>
                          <ng-template ngbNavContent>
                            <p class="text-center">Rating filters are coming soon.</p>
                          </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem="1">
                          <button ngbNavLink>
                            <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                            Price Range
                          </button>
                          <ng-template ngbNavContent>
                            <div class="checkbox-wrap-row">
                              <div class="row">
                                <div class="col-12" *ngFor="let price of priceRanges;let i = index;">
                                  <div class="form-check">
                                    <input type="checkbox" [(ngModel)]="selectedPrices[i]"
                                           (ngModelChange)="onfilter($event);addToChip($event,price,false,articleFilterTabType.PriceRangeTab)"
                                           class="form-check-input" [id]="'pricerange-'+i" />
                                    <label class="form-check-label" [for]="'pricerange-'+i">
                                      {{price?.title}}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem="2">
                          <button ngbNavLink>
                            <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                            Type of Meal
                          </button>
                          <ng-template ngbNavContent>
                            <div class="checkbox-wrap-row">
                              <div class="row">
                                <div class="col-12" *ngFor="let meal of typeOfMeals;let i= index">
                                  <div class="form-check">
                                    <input type="checkbox" [(ngModel)]="selectedTypeOfMeals[i]"
                                           (ngModelChange)="onfilter($event);addToChip($event,meal,false,articleFilterTabType.TypeOfMealTab)"
                                           class="form-check-input" [id]="'meal-'+i" />
                                    <label class="form-check-label" [for]="'meal-'+i">
                                      {{meal?.title}}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>

                      <div [ngbNavOutlet]="nav"></div>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container ngbNavItem="categories">
                  <button ngbNavLink>Categories</button>
                  <ng-template ngbNavContent>
                    <div class="inner-tab-block">
                      <div ngbNav #nav="ngbNav" [(activeId)]="activeInner" class="nav-tabs">
                        <ng-container ngbNavItem="1">
                          <button ngbNavLink class="dashboard-categories-filter-btn">
                            <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                            Type Of Category
                          </button>
                          <ng-template ngbNavContent>
                            <div #scrollBarContainer class="dropdown-scroll-wrapper">
                              <div class="checkbox-wrap-row dropdown-scroll-wrapper">
                                <div class="row">
                                  <div class="col-12" *ngFor="let category of categories;let i=index">
                                    <div class="form-check">
                                      <input type="checkbox" [(ngModel)]="selectedCategories[i]"
                                             (ngModelChange)="onfilter($event);addToChip($event,category,false,articleFilterTabType.CategoryTab)"
                                             class="form-check-input" [id]="'category-'+i" />
                                      <label class="form-check-label" [for]="'category-'+i">
                                        {{category?.title}}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>

                      <div [ngbNavOutlet]="nav"></div>
                    </div>
                  </ng-template>
                </ng-container>
              </div>
              <div [ngbNavOutlet]="nav" class="outer-tab-content"></div>
            </div>
            <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap d-md-none">
              <div class="chips-inner">
                <div class="chip" *ngFor="let chips of displayFilterChips">
                  <span>{{chips.name}}</span>
                  <button (click)="removeChips(chips);onfilter($event);" class="btn">
                    <img src="./assets/images/ic-close.svg" alt="Icon">
                  </button>
                </div>
              </div>
            </div>
            <div class="cta-btn-wrap d-md-none" [class.location-editor-open]="isMobileLocationSearchOpen">
              <button type="button"
                      class="btn btn-outline-primary with-icon mobile-location-trigger" data-tour="location-control"
                      [class.d-none]="isMobileLocationSearchOpen"
                      [title]="mobileLocationLabel"
                      (click)="openMobileLocationSearch($event)">
                <div class="svg-wrap">
                  <img src="./assets/images/ic-location.svg" alt="Icon">
                </div>
                <span class="location-trigger-label">{{ mobileLocationLabel }}</span>
                <span *ngIf="hasMobileLocationSelection"
                      class="mobile-location-clear"
                      role="button"
                      aria-label="Clear location"
                      (click)="clearMobileLocation($event)">
                  &times;
                </span>
              </button>
              <ng-container *ngTemplateOutlet="listingOpenClosePills"></ng-container>
              <!-- <button class="btn btn-outline-primary with-icon" disabled>
                <div class="svg-wrap">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0 5.77778V0H5.77778V5.77778H0ZM2.16667 2.16667V3.61111H3.61111V2.16667H2.16667ZM7.22222 5.77778V0H13V5.77778H7.22222ZM9.38889 2.16667V3.61111H10.8333V2.16667H9.38889ZM0 7.22222V13H5.77778V7.22222H0ZM3.61111 9.38889V10.8333H2.16667V9.38889H3.61111ZM9.38889 7.22222H7.22222V8.66667H9.38889V11.5556H8.66667V10.1111H7.22222V13H10.1111V11.5556H11.5556V13H13V10.8333H11.5556V10.1111H10.8333V9.38889H13V7.22222H10.8333V8.66667H9.38889V7.22222Z"
                      fill="currentcolor" />
                  </svg>
                </div>
                Scan
              </button> -->
            </div>
          </div>
        </div>
        <!-- Open/Closeby live in three places (filter panel, beside the open location field, and
             the active-filter row), so they are declared once here. -->
        <ng-template #listingOpenClosePills>
          <button class="btn btn-outline-primary" [ngClass]="{'btn-clicked':showOpen,}"
                  (click)="showOpenResturant()">
            Open
          </button>
          <button class="btn btn-outline-primary" [ngClass]="{'btn-clicked':showClose}"
                  (click)="showCloseResturant()">
            Closeby
          </button>
        </ng-template>
        <!-- Active filters stay on screen with the panel closed, so they can be removed without
             reopening it. -->
        <div class="mobile-active-filters d-md-none"
             *ngIf="(hasMobileLocationSelection || showOpen || showClose)
                    && !isMobileLocationSearchOpen && !myDrop.isOpen()">
          <button type="button"
                  *ngIf="hasMobileLocationSelection"
                  class="btn btn-outline-primary with-icon mobile-location-trigger" data-tour="location-control"
                  [title]="mobileLocationLabel"
                  (click)="openMobileLocationSearch($event)">
            <div class="svg-wrap">
              <img src="./assets/images/ic-location.svg" alt="Icon">
            </div>
            <span class="location-trigger-label">{{ mobileLocationLabel }}</span>
            <span class="mobile-location-clear"
                  role="button"
                  aria-label="Remove location filter"
                  (click)="clearMobileLocation($event)">
              <!-- SVG rather than &times;: that glyph sits off its box's centre and ignores the
                   box size. currentColor lets it flip to white with the pill on hover. -->
              <svg width="13" height="13" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
                <path d="M2.6 2.6 L9.4 9.4 M9.4 2.6 L2.6 9.4" stroke="currentColor"
                      stroke-width="1.9" stroke-linecap="round" />
              </svg>
            </span>
          </button>
          <button *ngIf="showOpen" class="btn btn-outline-primary btn-clicked with-clear"
                  (click)="showOpenResturant()">
            Open
            <span class="mobile-location-clear" aria-hidden="true">&times;</span>
          </button>
          <button *ngIf="showClose" class="btn btn-outline-primary btn-clicked with-clear"
                  (click)="showCloseResturant()">
            Closeby
            <span class="mobile-location-clear" aria-hidden="true">&times;</span>
          </button>
        </div>
        <button class="btn btn-view btn-search" [ngClass]="{'typing':searchText,'btn-clicked':isSearchBtnClick}"
                (click)="isSearchBtnClick=!isSearchBtnClick;viewSearchBar($event);myDrop.close();collapseDesktopLocationSearch()">
          <div class="svg-wrap">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1229_1466)">
                <path d="M21.5 21.5L17.014 17.006M19.5 11C19.5 13.2543 18.6045 15.4163 17.0104 17.0104C15.4163 18.6045 13.2543 19.5 11 19.5C8.74566 19.5 6.58365 18.6045 4.98959 17.0104C3.39553 15.4163 2.5 13.2543 2.5 11C2.5 8.74566 3.39553 6.58365 4.98959 4.98959C6.58365 3.39553 8.74566 2.5 11 2.5C13.2543 2.5 15.4163 3.39553 17.0104 4.98959C18.6045 6.58365 19.5 8.74566 19.5 11Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
              </g>
              <defs>
                <clipPath id="clip0_1229_1466">
                  <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </button>
      </div>
      <!--  -->

      <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap filter-chips-wrap-cst d-none d-md-flex">
        <div class="chips-inner">
          <div class="chip" *ngFor="let chip of displayFilterChips">
            <span *ngIf="chip.name">{{chip.name}}</span>
            <button (click)="removeChips(chip);onfilter($event);" class="btn btn-chips">
              <img src="./assets/images/ic-close.svg" alt="Icon">
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="location-map-frame">
    <div #mapElement id="map" style="height: 100%; width: 100%; max-height: 452px" referrerpolicy="no-referrer-when-downgrade">
    </div>
    <!-- Map-scoped loader: the auto-unzoom cycle must not block the whole page. -->
    <div class="loader-wrapper map-scoped-loader" [ngClass]="{'d-none': !isLoading}">
      <span class="loader"></span>
    </div>
  </div>
</div>
